// @ts-nocheck
import styled from 'styled-components';
import { LayoutItem } from '@oneaudi/unified-web-components';

import type { HTMLAttributes } from 'react';
import type React from 'react';

export type LayoutContainerProps = HTMLAttributes<HTMLDivElement> & {
  theme?: Record<string, unknown>;
  style?: React.CSSProperties;
};
export const LayoutContainer = styled<React.FC<LayoutContainerProps>>(LayoutItem)`
  ${(props) => props.style}
`;
